export const techStack: string[] = [
  "typescript",
  "react",
  "node",
  "linux",
  "networking",
  "cryptography",
  "security tooling",
  "infrastructure automation"
]